import { reactive, ref } from 'vue';
import { defineStore } from 'pinia';
import { ActivityModel, type ActivityResponse } from '@/models/activity';
import ActivityService from '@/services/activityService';
import { useStudyStore } from './study';
import { LoadingStateModel } from '@/models/loadingState';
import { useRoute } from 'vue-router';

export const useActivityStore = defineStore('activity', () => {
  const studyStore = useStudyStore();

  const activityCount = ref<number>(0);
  const activityList = ref<ActivityModel[]>([]);
  const LIMIT = ref<number>(10);
  const route = useRoute();


  const isActvityLoading = reactive(new LoadingStateModel({isLoading: false}));
  const getActivityActions = async (page: number) => {
    if (route.params.studyIdentifier) {
      studyStore.selectedStudyId = route.params.studyIdentifier as string;
    }
    if (studyStore.selectedStudyId) {
      try {
        isActvityLoading.startLoading();
        const activitiesRes: ActivityResponse = await ActivityService.getActivityActions(
          studyStore.selectedStudyId,
          LIMIT.value,
          page
        ) as ActivityResponse;
        if (activitiesRes.activities && activitiesRes.activityCount) {
          activityCount.value = activitiesRes.activityCount;
          activityList.value = activitiesRes.activities;
        }
      } catch (error) {
        isActvityLoading.setError(error);
      } finally {
        isActvityLoading.stopLoadingAndFinish();
      }
    }
  };

  return {
    getActivityActions,
    activityCount,
    activityList,
    LIMIT,
    isActvityLoading
  };
});
